import { create } from "apisauce";
import { Config } from "../config";

const userApiClient = create({
  /**
   * Import the config from the App/Config/index.js file
   */
  baseURL: Config.API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 2500000,
});

const userApiClientTest = create({
  /**
   * Import the config from the App/Config/index.js file
   */
  baseURL: Config.API_URL_TEST,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 2500000,
});
const chatApiClient = create({
  /**
   * Import the config from the App/Config/index.js file
   */
  baseURL: Config.CHAT_API_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 2500000,
});

const userClassLinkApiClient = create({
  /**
   * Import the config from the App/Config/index.js file
   */
  baseURL: Config.API_URL_CLASS_LINK,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  timeout: 100000,
});

// function apiClient(metaData, accessToken) {
//   const headers = {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     ...(accessToken && { Authorization: "Bearer " + accessToken }),
//     ...metaData,
//   };
//   return create({
//     baseURL: Config.LIVE_URL,
//     headers,
//     timeout: 10000,
//   });
// }

// function refreshToken(userId, token) {
//   return apiClient({})
//     .post(EndPoints.REFRESH_TOKEN, {
//       UserID: userId,
//       RefreshToken: token,
//     })
//     .then((response) => processReponse(response));
// }

// function processReponse(response, isArray) {
//   const { Data, Token, StatusCode, StatusMessage, MessageID } = response.data;
//   // console.log("*** API RESPONSE : ", response)
//   if (Data || Token) {
//     const apiData = {
//       Data:
//         Array.isArray(Data) && Data.length === 1 && !isArray ? Data[0] : Data,
//       Token,
//     };
//     return apiData;
//   } else if (StatusMessage === INVALID_REFRESH && StatusCode === 400) {
//     return INVALID_REFRESH;
//   } else if (StatusMessage === "Unauthorized user." && StatusCode === 401) {
//     return TOKEN_EXPIRED;
//   } else {
//     return {
//       Data: {
//         MessageID,
//       },
//     };
//   }
// }

//classlink login
function classLinkLogin(loginId) {
  // Used to call user signin function
  return userClassLinkApiClient
    .get("/AuthenticateClasslinkStudentLogin", { LoginID: loginId })
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Login service
function userLogin(username, password, domain) {
  return userApiClientTest
    .post("/StudentLogin", {
      LoginName: username,
      Password: password,
      DistrictName: domain,
    })
    .then((response) => {
      console.log("loginRespons", response);
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return response.data;
      }
    });
}

//Login service
function refreshToken(tokenData, domain) {
  return userApiClientTest
    .post("/RefreshToken", {
      TenantID: tokenData.TenantID,
      UserID: tokenData.UserID,
      UserType: tokenData.UserType,
      RefreshToken: tokenData.RefreshToken,
    })
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return response.data;
      }
    });
}

//Login - Forgot password
function forgotPasswordStudent(LoginName, DomainName) {
  return userApiClient
    .get("/SendBackpackForgotPassword", {
      LoginName: LoginName,
      DomainName: DomainName,
    })
    .then((response) => {
      if (response.ok) {
        return response;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Dashboard - course list service
function getCourseListForStudent(loginId, token) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      LoginID: loginId,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBPStudentDashboard", {})
    .then((response) => {
      if (response.data) {
        return response.data;
        // return response.data.GetBPStudentDashboardResult;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}
//Dashboard - chapter list service
function getChapterListForStudent(subjectId, loginId, token) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      SubjectID: subjectId,
      LoginID: loginId,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBPAllChaptersBySubject", {})
    .then((response) => {
      console.log("response", response);
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Lesson folder service
function getLessonFoldersForStudent(
  studentId,
  DomainID,
  SubjectID,
  ChapterID,
  token
) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      DomainID: DomainID,
      StudentID: studentId,
      SubjectID: SubjectID,
      ChapterID: ChapterID,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBPLessonFoldersBySubject", {})

    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Dashboard - Upcoming assignments service
function getUpcomingAssignmentForStudent(studentId, assignmentDate, token) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: studentId,
      AssignmentDate: assignmentDate,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBPUpcomingAssignments", {})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}
//Lesson units Details
function getLessonUnitsForAStudent(
  studentId,
  courseId,
  lessonId,
  ChapterID,
  token
) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: studentId,
      CourseID: courseId,
      LessonID: lessonId,
      ChapterID: ChapterID,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetLessonUnitsForAStudent", {})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Lesson Details - Pending assignments service
function getPendingAssignmentDataForStudent(
  studentId,
  courseId,
  lessonId,
  ChapterID,
  token
) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: studentId,
      CourseID: courseId,
      LessonID: lessonId,
      ChapterID: ChapterID,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetPendingLessonUnitsForAStudent", {})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Lesson Details - Completed assignments service
function getCompletedLessonUnitDetailsForStudent(
  studentId,
  lessonId,
  ChapterID,
  token
) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: studentId,
      LessonID: lessonId,
      ChapterID: ChapterID,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBPCompletedLessonUnitsByLesson", {})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Lesson Details - Popup details service
function getAssignmentDataSummaryForStudent(studentId, lessonUnitDistId) {
  return userApiClient
    .get("/GetLessonUnitSummaryForAStudent", {
      StudentID: studentId,
      LessonUnitDistID: lessonUnitDistId,
    })
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Lesson Details - Unlock offline course
function unlockOfflineCourse(unlockcourse) {
  return userApiClient
    .put("/UnlockOfflineLessonUnitByCourseID", unlockcourse)
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Lesson Details - Unlock offline lesson
function unlockOfflineLessonUnit(unlocklesson) {
  return userApiClient
    .put("/UnlockOfflineLessonUnitByLessonUnitDistID", unlocklesson)
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//TOC - List of activity service
function getLessonUnitDetailsForStudent(studentId, lessonUnitDistId, token) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: studentId,
      LessonUnitDistID: lessonUnitDistId,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetLessonUnitDetailsForAStudent", {})
    .then((response) => {
      console.log("response", response);
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Get particular activity details service
function getActivityForStudent(StudentID, ContentID, token) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: StudentID,
      ContentID: ContentID,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBackpackActivityForStudent", {})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//get contained activity for marker
function getContainedActivityForStudent(StudentID, ContentID, token) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
      StudentID: StudentID,
      ContentID: ContentID,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .get("/GetBackpackActivityForStudent", {})
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Save user works
function saveActivityForStudent(token, activity) {
  const userApiClientHeader = create({
    baseURL: Config.API_URL_TEST,
    headers: {
      accept: "text/plain",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token.AccessToken,
    },
    timeout: 100000,
  });
  return userApiClientHeader
    .post("/SaveBackpackActivityForStudent", activity)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return response.data;
      }
    });
}

//Analytics - Course summary Service
function getCourseSummaryAnalyticsReport(DomainID, CourseID, StudentID) {
  return userApiClient
    .get("/GetCourseSummaryAnalyticsReport", {
      DomainID: DomainID,
      CourseID: CourseID,
      StudentID: StudentID,
    })
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Analytics - Lessonpod summary Service
function getLessonPodSummaryAnalyticsReport(LessonUnitDistID, StudentID) {
  return userApiClient
    .get("/GetLessonPodSummaryAnalyticsReport", {
      LessonUnitDistID: LessonUnitDistID,
      StudentID: StudentID,
    })
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Analytics - Activity summary Service
function getLessonPodActivityAnalyticsReport(ContentID, StudentID) {
  return userApiClient
    .get("/GetLessonPodActivityAnalyticsReport", {
      ContentID: ContentID,
      StudentID: StudentID,
    })
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

function getLessonFolderBySubject(DomainID, StudentID, SubjectID) {
  return userApiClient
    .get("/GetBPLessonFoldersBySubject", {
      DomainID: DomainID,
      StudentID: StudentID,
      SubjectID: SubjectID,
    })
    .then((response) => {
      if (response.ok) {
        return response;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

function getLessonUnitsByFolder(StudentID, LessonID) {
  return userApiClient
    .get("/GetBPLessonFoldersBySubject", {
      StudentID: StudentID,
      LessonID: LessonID,
    })
    .then((response) => {
      if (response.ok) {
        return response;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

function clearH5P(username, password, domain) {
  return userApiClient
    .get("/AuthenticateStudentLogin", {
      LoginName: username,
      Password: password,
      DomainName: domain,
    })
    .then((response) => {
      if (response.ok) {
        return response.data;
      } else if (response.problem === "TIMEOUT_ERROR") {
        return response.problem;
      } else {
        return null;
      }
    });
}

//Chat challange me service
function chatChallengeMe(
  serviceTypeName,
  topic,
  keyword,
  question_type,
  num_of_options,
  content
) {
  if (serviceTypeName === "challenge") {
    return chatApiClient
      .post(serviceTypeName, {
        topic: topic,
        keyword: keyword,
        question_type: question_type,
        num_of_options: num_of_options,
        content: content,
      })
      .then((response) => {
        if (response.ok) {
          return response.data;
        } else if (response.problem === "TIMEOUT_ERROR") {
          return response.problem;
        } else {
          return null;
        }
      });
  } else if (serviceTypeName === "translated-content") {
    return chatApiClient
      .post(serviceTypeName, {
        language: topic,
        content: content,
      })
      .then((response) => {
        if (response.ok) {
          return response.data;
        } else if (response.problem === "TIMEOUT_ERROR") {
          return response.problem;
        } else {
          return null;
        }
      });
  } else {
    return chatApiClient
      .post(serviceTypeName, {
        topic: topic,
        keyword: keyword,
        content: content,
      })
      .then((response) => {
        if (response.ok) {
          return response.data;
        } else if (response.problem === "TIMEOUT_ERROR") {
          return response.problem;
        } else {
          return null;
        }
      });
  }
}

export const userService = {
  classLinkLogin,
  userLogin,
  refreshToken,
  getCourseListForStudent,
  getChapterListForStudent,
  getPendingAssignmentDataForStudent,
  getLessonFoldersForStudent,
  getLessonUnitsForAStudent,
  getAssignmentDataSummaryForStudent,
  getLessonUnitDetailsForStudent,
  getCompletedLessonUnitDetailsForStudent,
  saveActivityForStudent,
  unlockOfflineLessonUnit,
  unlockOfflineCourse,
  getActivityForStudent,
  getUpcomingAssignmentForStudent,
  forgotPasswordStudent,
  getLessonFolderBySubject,
  getLessonUnitsByFolder,
  getCourseSummaryAnalyticsReport,
  getLessonPodSummaryAnalyticsReport,
  getLessonPodActivityAnalyticsReport,
  getContainedActivityForStudent,
  chatChallengeMe,
};
